// extracted by mini-css-extract-plugin
module.exports = {"container":"_2AaX_lhO8B9rFUDxTzdlSL","groupsList":"_2F6bGXV2wvVSXXkYfhf5h4"};